"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportJdOrder = exportJdOrder;
exports.getIntegralLog = getIntegralLog;
exports.getJdOrderDetail = getJdOrderDetail;
exports.getJdOrderList = getJdOrderList;
exports.getOrderStatusGrouped = getOrderStatusGrouped;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 京东订单列表
 */
function getJdOrderList(params) {
  return (0, _request.default)({
    url: '/admin/lyp/order/jd/list',
    method: 'POST',
    data: params || {}
  });
}

/**
 * 订单状态（分组）
 */
function getOrderStatusGrouped() {
  return (0, _request.default)({
    url: '/admin/lyp/order/order-status/grouped',
    method: 'POST'
  });
}

/**
 * 京东订单导出
 */
function exportJdOrder(params) {
  return (0, _request.default)({
    url: '/admin/jd/order/export',
    method: 'GET',
    params: params
  });
}

/**
 * 京东订单详情
 */
function getJdOrderDetail(orderNo) {
  return (0, _request.default)({
    url: '/admin/lyp/order/jd/detail',
    method: 'POST',
    data: {
      orderNo: orderNo
    }
  });
}

/**
 * 积分/福豆使用明细
 * @param {string|number} orderNo 订单号
 */
function getIntegralLog(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/station/getIntegralLog/".concat(orderNo),
    method: 'get'
  });
}